/**
 * TypeScript типы для Mini App
 */

// ==================== Settings ====================

export interface UserSettings {
  receiveNotifications: boolean;
  reminderInterval: number;
  quietHoursEnabled: boolean;
  quietHoursStart: number;
  quietHoursEnd: number;
  notifyNeedsResponse: boolean;
  notifyInProgress: boolean;
  notifyWaitingCustomer: boolean;
}

// ==================== Admin ====================

export interface AdminMe {
  isAdmin: boolean;
}

export interface InviteCode {
  code: string;
  expiresAt: string;
  createdBy: number;
  used: boolean;
}

export interface AdminUser {
  chatId: number;
  username: string | null;
  firstName: string | null;
  lastName: string | null;
  active: boolean;
  receiveNotifications: boolean;
  lastActivity: string | null;
}

export interface CleanupResult {
  deleted: number;
}

// ==================== Stats ====================

export interface MemberStat {
  member: string;
  count: number;
}

export interface RequestBrief {
  id: number;
  subject: string;
  completedAt?: string;
}

// ==================== Navigation ====================

export interface TabItem {
  id: string;
  path: string;
  icon: string;
  label: string;
  adminOnly?: boolean;
}

export const TABS: TabItem[] = [
  { id: 'requests', path: '/', icon: '📋', label: 'Заявки' },
  { id: 'stats', path: '/stats', icon: '📊', label: 'Статистика' },
  { id: 'settings', path: '/settings', icon: '⚙️', label: 'Настройки' },
  { id: 'admin', path: '/admin', icon: '👑', label: 'Админ', adminOnly: true },
];

// ==================== Constants ====================

export const INTERVAL_OPTIONS = [
  { value: 0, label: 'Выкл' },
  { value: 5, label: '5 мин' },
  { value: 15, label: '15 мин' },
  { value: 30, label: '30 мин' },
  { value: 60, label: '1 час' },
  { value: 120, label: '2 часа' },
  { value: 180, label: '3 часа' },
  { value: 240, label: '4 часа' },
] as const;

export const QUIET_HOURS_PRESETS = [
  { start: 22, end: 8, label: '22:00 - 08:00' },
  { start: 23, end: 7, label: '23:00 - 07:00' },
  { start: 0, end: 9, label: '00:00 - 09:00' },
  { start: 21, end: 6, label: '21:00 - 06:00' },
] as const;
